/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '../../common/ui/index.tsx';
import historicalCycleTimeSVG from './assets/historical-cycle-time-app-skeleton.tpl.svg';
import issueChartSVG from './assets/issue-chart-app-skeleton.tpl.svg';
import issueTableSVG from './assets/issue-table-app-skeleton.tpl.svg';
import periodFilterSVG from './assets/period-filter-app-skeleton.tpl.svg';

const withBorderCssStyles = css({
	borderRightWidth: '16px',
	borderLeftWidth: '16px',
});

const topBorderCssStyles = css({
	borderRightWidth: '16px',
	borderLeftWidth: '16px',
	borderTopWidth: '16px',
});

const noBorderCssStyles = css({
	borderRightWidth: '0',
	borderLeftWidth: '0',
});

export const HistoricalCycleTimeSkeleton = () => (
	<AppSkeletonImage
		containerStyles={{ height: '22em' }}
		css={withBorderCssStyles}
		src={historicalCycleTimeSVG}
	/>
);

export const IssueChartSkeleton = () => (
	<AppSkeletonImage
		containerStyles={{ height: '32em' }}
		css={topBorderCssStyles}
		src={issueChartSVG}
	/>
);

export const PeriodFilterSkeleton = () => (
	<AppSkeletonImage
		containerStyles={{ height: '3em' }}
		css={withBorderCssStyles}
		src={periodFilterSVG}
	/>
);

export const IssueTableSkeleton = () => (
	<AppSkeletonImage
		containerStyles={{ height: '12em' }}
		css={noBorderCssStyles}
		src={issueTableSVG}
	/>
);
